import Vue from "vue";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {library} from "@fortawesome/fontawesome-svg-core";
import {
    faHouse,
    faBarcode,
    faMagnifyingGlass,
    faPlus,
    faMinus,
    faBars,
    faFileExcel,
    faFilePdf,
    faAngleRight,
    faArrowLeft,
    faDeleteLeft,
    faUser,
    faBox,
    faExternalLinkAlt,
    faDolly,
    faCartShopping,
    faPaperPlane,
    faBuilding,
    faClose,
    faCashRegister,
    faBoxes,
    faLock,
    faBasketShopping,
    faBoxesStacked,
    faCodeFork,
    faReceipt,
    faGear,
    faXmark,
    faChevronRight,
    faArrowRightFromBracket,
    faCreditCard,
    faMoneyBillWave,
    faMoneyBill,
    faAnglesUp,
    faAnglesDown,
    faChevronUp,
    faChevronDown,
    faPercentage,
    faCheckCircle,
    faBowlFood,
    faArrowsRotate,
    faLayerGroup,
    faPenToSquare,
    faUsers,
    faUserPlus,
    faHandHoldingDollar,
    faCoins,
    faArrowRotateLeft,
    faGears,
    faMoneyBills,
    faArrowTrendDown,
    faPrint,
    faTrash,
    faTable,
    faSave,
    faChartLine,
    faUpload,
    faFolderTree,
    faCancel,
    faCommentsDollar,
    faArrowsSplitUpAndLeft,
    faQuestionCircle,
    faChartSimple,
    faHandHoldingDroplet,
    faEnvelope,
    faExchange,
    faSliders,
    faArrowDown,
    faArrowUp,
    faShuffle,
    faArrowRight,
    faChartBar,
    faEye,
    faMoneyCheck,
    faExclamationCircle,
    faBell,
    faUserGear,
    faBusinessTime,
    faFingerprint,
    faImage,
    faCheck,
    faMoneyCheckDollar,
    faCubesStacked,
    faTag,
    faSackDollar,
    faFilterCircleDollar,
    faBuildingColumns,
    faPlusMinus,
    faArrowRightLong,
    faCubes,
    faCartArrowDown,
    faMask,
    faScaleBalanced,
    faMoneyBill1Wave,
    faVault,
    faRotate,
    faRotateLeft,
    faFileImport,
    faTruck,
    faTruckLoading,
    faTruckRampBox,
    faFileInvoice,
    faClockRotateLeft,
    faTransgender,
    faArrowUpWideShort,
    faFileInvoiceDollar,
    faTriangleExclamation,
    faTags,
    faTrashCan,
    faStore,
    faDollarSign,
    faCalendarXmark,
    faChartPie,
    faFileExport,
    faSitemap,
    faMoneyBillTransfer,
    faClipboardList,
    faTimes,
    faSignOutAlt,
    faEllipsisVertical,
    faSun,
    faMoon,
    faAdd,
    faDownload,
    faInfoCircle,
    faShareFromSquare,
    faSearch,
    faSync,
    faArrowTrendUp,
    faArrowDownShortWide,
    faList,
    faCircle,
    faSquare,
    faCircleCheck,
    faSquareCheck,
    faListOl,
    faArrowDownAZ,
    faArrowUpAZ,
    faFilter,
    faCalendar,
    faFolderOpen,
    faFlag,
    faHashtag,
    faCircleExclamation,
    faMessage,
    faSpinner,
    faClock,
    faBook,
    faRocket,
    faArrowUpRightFromSquare,
    faLightbulb,
    faWifi,
    faPlugCircleXmark
} from "@fortawesome/free-solid-svg-icons";

import {
    faCalendarAlt
} from "@fortawesome/free-regular-svg-icons";

// Alias solid faStore as a regular icon to satisfy usages like ['far', 'store']
const farStore = { ...faStore, prefix: 'far' };
// Alias regular calendar-alt as solid for legacy ['fas', 'calendar-alt'] usage
const fasCalendarAlt = { ...faCalendarAlt, prefix: 'fas' };

Vue.component("font-awesome-icon", FontAwesomeIcon);
library.add(
    faHouse,
    faBarcode,
    faBox,
    faDolly,
    faMagnifyingGlass,
    faClose,
    faPlus,
    faMinus,
    faMoneyBill,
    faBuilding,
    faBars,
    faAngleRight,
    faArrowLeft,
    faUser,
    faChevronUp,
    faChevronDown,
    faPercentage,
    faFingerprint,
    faCheckCircle,
    faAnglesUp,
    faAnglesDown,
    faDeleteLeft,
    faCartShopping,
    faPaperPlane,
    faCashRegister,
    faBoxes,
    faLock,
    faBasketShopping,
    faBoxesStacked,
    faReceipt,
    faGear,
    faArrowRightFromBracket,
    faXmark,
    faChevronRight,
    faCreditCard,
    faMoneyBill,
    faArrowsRotate,
    faLayerGroup,
    faPenToSquare,
    faUsers,
    faHandHoldingDollar,
    faCoins,
    faUserPlus,
    faBell,
    faArrowRotateLeft,
    faGears,
    faMoneyBills,
    faArrowTrendDown,
    faPrint,
    faTrash,
    faTable,
    faSave,
    faArrowsRotate,
    faLayerGroup,
    faCodeFork,
    faUsers,
    faHandHoldingDollar,
    faCoins,
    faUserPlus,
    faChartLine,
    faUpload,
    faFolderTree,
    faUserGear,
    faCommentsDollar,
    faBowlFood,
    faArrowsSplitUpAndLeft,
    faQuestionCircle,
    faChartSimple,
    faHandHoldingDroplet,
    faEnvelope,
    faExchange,
    faCancel,
    faSliders,
    faArrowDown,
    faArrowUp,
    faShuffle,
    faArrowRight,
    faChartBar,
    faEye,
    faMoneyCheck,
    faExclamationCircle,
    faBusinessTime,
    faImage,
    faCheck,
    faMoneyCheckDollar,
    faCubesStacked,
    faTag,
    faSackDollar,
    faFilterCircleDollar,
    faBuildingColumns,
    faPlusMinus,
    faArrowRightLong,
    faCubes,
    faCartArrowDown,
    faMask,
    faScaleBalanced,
    faMoneyBill1Wave,
    faVault,
    faRotate,
    faRotateLeft,
    faFileImport,
    faTruck,
    faTruckLoading,
    faTruckRampBox,
    faFileInvoice,
    faClockRotateLeft,
    faTransgender,
    faArrowUpWideShort,
    faFileInvoiceDollar,
    faTriangleExclamation,
    faTags,
    faTrashCan,
    faDollarSign,
    faCalendarXmark,
    faChartPie,
    faFileExport,
    faSitemap,
    faMoneyBillTransfer,
    faCalendarAlt,
    fasCalendarAlt,
    faBuilding,
    faClipboardList,
    faFileExcel,
    faExternalLinkAlt,
    faTimes,
    faSignOutAlt,
    faEllipsisVertical,
    faSun,
    faMoon,
    faAdd,
    faDownload,
    faInfoCircle,
    faShareFromSquare,
    faSearch,
    faSync,
    faArrowTrendUp,
    faArrowDownShortWide,
    faList,
    faCircle,
    faSquare,
    faCircleCheck,
    faSquareCheck,
    faListOl,
    faArrowDownAZ,
    faArrowUpAZ,
    faFilter,
    faCalendar,
    faFolderOpen,
    faFlag,
    faHashtag,
    faCircleExclamation,
    faMessage,
    faSpinner,
    faClock,
    faStore,
    faFilePdf,
    faMoneyBillWave,
    faMoneyBill,
    farStore,
    faBook,
    faRocket,
    faArrowUpRightFromSquare,
    faLightbulb,
    faWifi,
    faPlugCircleXmark,
);
